import React from 'react'
import './contact.css'
import {MdOutlineEmail} from 'react-icons/md'
import {AiFillInstagram} from 'react-icons/ai'
import {AiFillYoutube} from 'react-icons/ai'
import {BsLinkedin} from 'react-icons/bs'
import { useRef } from 'react';
import emailjs from 'emailjs-com'

const Contact = () => {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_xamzslu', 'template_qxsw8sl', form.current, 'zLEBia-z5LJnK9871')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });

      e.target.reset();
  };

  return (
    <section id="contact">
      <h5>Let's Collaborate</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineEmail className="contact__option-icon"/>
            <h4>Email</h4>
            <a href="mailto:ataglanceofficial@gmail.com" target="_blank">Send a message</a>
          </article>
          <article className="contact__option">
            <AiFillYoutube className="contact__option-icon"/>
            <h4>YouTube</h4>
            <a href="https://www.youtube.com/@ataglanceofficial" target="_blank">Subscribe</a>
          </article>
          <article className="contact__option">
            <AiFillInstagram className="contact__option-icon"/>
            <h4>Instagram</h4>
            <a href="https://www.instagram.com/at_a_glance_official/" target="_blank">Send a message</a>
          </article>
        </div>
        {/* END OF CONTACT OPTIONS */}
        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name="name" placeholder='Your Full Name' required />
          <input type="email" name="email" placeholder='Your Email' required />
          <textarea name="message" rows="7" placeholder='Your Message' required />
          <button type='submit' className='btn btn-primary'>Send Message</button>
        </form>
      </div>
    </section>
  )
}

export default Contact